import React from 'react';
import './OverAlls.scss';
import SubHeader from '../../../components/subheader/SubHeader';
import TotalCard from '../../../components/cost/totalcard/TotalCard';
import ColumnsChart from '../../../components/revenue/onplan/columnschart/ColumnsChart';
import ColumnsChart2 from '../../../components/revenue/onplan/columnschart/ColumnsChart2';
import WaterFallChart from '../../../components/cost/waterfallchart/WaterFallChart';
import ClusterdBarChart from '../../../components/cost/clusteredbarchart/ClusteredBarChart';
import RevenueBarChart from '../../../components/revenue/revenuebarchart/RevenueBarChart';
import DonutChartLine from '../../../components/cost/donutchartline/DonutChartLine';
import RevenueTableCategories from '../../../components/revenue/revenuetablecategories/RevenueTableCategories';
import IconCost from '../../../assets/image/cost/Icon-total-cost.svg';
import {
  renameKeysCost,
} from '../../../utils/formatdatarevenue/RevenueFormater';
import { AppContext } from '../../../context/Context';
import { useContext } from 'react';
import {
  getQuarterByMonth,
  createRevenueDateTitle,
  createRevenueCardQuarterTitle,
  createRevenueCardMonthTitle,
  toMillionFormat,
} from './../../../utils/format';

const OverAll = () => {
  const { data, fromDate, toDate } = useContext(AppContext);

  const allData = data.cost?.commisson.overall.costoverallmonths || [];

  const firstRevenueYearMonth =
    allData.length > 0 ? allData[0].year_month : null;

  const lastRevenueYearMonth =
    allData.length > 0 ? allData[allData.length - 1].year_month : null;

  const computeTotalCOGSYear = (fromDate, toDate, data) => {
    let total = 0;

    if (fromDate === 'All' || !toDate) {
      total =
        data.cost?.commisson.overall.costoverallmonthscolumns?.reduce(
          (sum, item) => sum + (item.goods_sold_cost || 0),
          0
        ) || 0;
    } else {
      const fromYear = parseInt(fromDate.split('-')[0]);
      const toYear = parseInt(toDate.split('-')[0]);

      total =
        data.cost?.commisson.overall.costoverallmonthscolumns
          ?.filter((item) => {
            const itemYear = parseInt(item.year_month.split('-')[0]);
            return itemYear >= fromYear && itemYear <= toYear;
          })
          .reduce((sum, item) => sum + (item.goods_sold_cost || 0), 0) || 0;
    }

    // Format with commas and 2 decimal places
    return total;
  };

  // const computeTotalCOGSQuarter = (fromDate, toDate, data) => {
  //   if (!data.cost?.commisson.overall.costoverallmonthscolumns) return 0;

  //   // Handle case "All"
  //   if (fromDate === "All" || !toDate) {
  //     const total = data.cost?.commisson.overall.costoverallmonthscolumns.reduce(
  //       (sum, item) => sum + (item.goods_sold_cost || 0),
  //       0
  //     );
  //     return total;
  //   }

  //   // Parse from/to
  //   const [fromYear, fromMonth] = fromDate.split("-").map(Number);
  //   const [toYear, toMonth] = toDate.split("-"

  //   ).map(Number);
  //   const fromQuarter = getQuarterByMonth(fromMonth);
  //   const toQuarter = getQuarterByMonth(toMonth);

  //   // --- Filter items that fall within these quarters ---
  //   const total = data.cost?.commisson.overall.costoverallmonthscolumns
  //     .filter((item) => {
  //       const [itemYear, itemMonth] = item.year_month.split("-").map(Number);
  //       const itemQuarter = getQuarterByMonth(itemMonth);

  //       if (itemYear < fromYear || itemYear > toYear) return false;
  //       if (itemYear === fromYear && itemQuarter < fromQuarter) return false;
  //       if (itemYear === toYear && itemQuarter > toQuarter) return false;
  //       return true;
  //     })
  //     .reduce((sum, item) => sum + (item.goods_sold_cost || 0), 0);

  //   // --- Format result ---
  //   return total;
  // };

  const computeTotalCOGSQuarter = (fromDate, toDate, data) => {
    if (!data?.cost?.commisson?.overall?.costoverallmonthscolumns) return 0;

    // Handle "All"
    if (fromDate === 'All' || !toDate) {
      return data.cost.commisson.overall.costoverallmonthscolumns.reduce(
        (sum, item) => sum + (item.goods_sold_cost || 0),
        0
      );
    }

    // --- Parse from/to year & month ---
    const [fromYear, fromMonth] = fromDate.split('-').map(Number);
    const [toYear, toMonth] = toDate.split('-').map(Number);

    const fromQuarter = getQuarterByMonth(fromMonth);
    const toQuarter = getQuarterByMonth(toMonth);

    // --- Filter ---
    const total = data.cost.commisson.overall.costoverallmonthscolumns
      .filter((item) => {
        const [itemYear, itemMonth] = item.year_month.split('-').map(Number);
        const itemQuarter = getQuarterByMonth(itemMonth);

        // year before range
        if (itemYear < fromYear || itemYear > toYear) return false;

        // same year as start
        if (itemYear === fromYear && itemQuarter < fromQuarter) return false;

        // same year as end
        if (itemYear === toYear && itemQuarter > toQuarter) return false;

        // in between years → always included
        return true;
      })
      .reduce((sum, item) => sum + (item.goods_sold_cost || 0), 0);

    return total;
  };

  const computeTotalCOGSCurrentMonth = (data) => {
    const COGS = data?.cost?.commisson?.overall.costoverallmonths;

    if (!Array.isArray(COGS)) return '0.00';

    const total = COGS.reduce(
      (sum, item) => sum + (item.goods_sold_cost || 0),
      0
    );

    return total;
  };

  const computeTotalCOGSPreviousMonth = (data) => {
    const COGS = data?.cost?.commisson?.overall.costoverallpreviousmonth;
    if (!Array.isArray(COGS)) return '0.00';

    const total = COGS.reduce(
      (sum, item) => sum + (item.goods_sold_cost || 0),
      0
    );

    return total;
  };

  const computeTotalAgentCommissionQuarter = (fromDate, toDate, data) => {
    if (!data?.cost?.commisson?.overall?.costOverAllCommissionColumns) return 0;

    // Handle "All"
    if (fromDate === 'All' || !toDate) {
      return data.cost.commisson.overall.costOverAllCommissionColumns.reduce(
        (sum, item) => sum + (item.agent_commission || 0),
        0
      );
    }

    // --- Parse from/to year & month ---
    const [fromYear, fromMonth] = fromDate.split('-').map(Number);
    const [toYear, toMonth] = toDate.split('-').map(Number);

    const fromQuarter = getQuarterByMonth(fromMonth);
    const toQuarter = getQuarterByMonth(toMonth);

    // --- Filter ---
    const total = data.cost.commisson.overall.costOverAllCommissionColumns
      .filter((item) => {
        const [itemYear, itemMonth] = item.year_month.split('-').map(Number);
        const itemQuarter = getQuarterByMonth(itemMonth);

        // year before range
        if (itemYear < fromYear || itemYear > toYear) return false;

        // same year as start
        if (itemYear === fromYear && itemQuarter < fromQuarter) return false;

        // same year as end
        if (itemYear === toYear && itemQuarter > toQuarter) return false;

        // in between years → always included
        return true;
      })
      .reduce((sum, item) => sum + (item.agent_commission || 0), 0);

    return total;
  };

  const computeTotalAgentCommissionCurrentMonth = (data) => {
    const agentCommission =
      data?.cost?.commisson?.overall.costoverallcommissionmonths;
    if (!Array.isArray(agentCommission)) return '0.00';

    const total = agentCommission.reduce(
      (sum, item) => sum + (item.agent_commission || 0),
      0
    );

    return total;
  };

  const computeTotalAgentCommissionPreviousMonth = (data) => {
    const agentCommission =
      data?.cost?.commisson?.overall.costoverallpreviousmonthcommission;
    if (!Array.isArray(agentCommission)) return '0.00';

    const total = agentCommission.reduce(
      (sum, item) => sum + (item.agent_commission || 0),
      0
    );

    return total;
  };

  const computeOtherAmountYear = (fromDate, toDate, data) => {
    let total = 0;

    if (fromDate === 'All' || !toDate) {
      total =
        data.cost?.commisson.overall.costOveralloheramountcolumns?.reduce(
          (sum, item) => sum + (item.goods_sold_cost || 0),
          0
        ) || 0;
    } else {
      const fromYear = parseInt(fromDate.split('-')[0]);
      const toYear = parseInt(toDate.split('-')[0]);

      total =
        data.cost?.commisson.overall.costOveralloheramountcolumns
          ?.filter((item) => {
            const itemYear = parseInt(item.year_month.split('-')[0]);
            return itemYear >= fromYear && itemYear <= toYear;
          })
          .reduce((sum, item) => sum + (item.goods_sold_cost || 0), 0) || 0;
    }

    // Format with commas and 2 decimal places
    return total;
  };

  // const computeOtherAmountQuarter = (fromDate, toDate, data) => {
  //     if (!data.cost?.commisson.overall.costOveralloheramountcolumns) return 0;

  //     // Handle case "All"
  //     if (fromDate === "All" || !toDate) {
  //       const total = data.cost?.commisson.overall.costOveralloheramountcolumns.reduce(
  //         (sum, item) => sum + (item.goods_sold_cost || 0),
  //         0
  //       );
  //       return total;
  //     }

  //     // Parse from/to
  //     const [fromYear, fromMonth] = fromDate.split("-").map(Number);
  //     const [toYear, toMonth] = toDate.split("-"

  //     ).map(Number);
  //     const fromQuarter = getQuarter(fromMonth);
  //     const toQuarter = getQuarter(toMonth);

  //     // --- Filter items that fall within these quarters ---
  //     const total = data.cost?.commisson.overall.costOveralloheramountcolumns
  //       .filter((item) => {
  //         const [itemYear, itemMonth] = item.year_month.split("-").map(Number);
  //         const itemQuarter = getQuarter(itemMonth);

  //         if (itemYear < fromYear || itemYear > toYear) return false;
  //         if (itemYear === fromYear && itemQuarter < fromQuarter) return false;
  //         if (itemYear === toYear && itemQuarter > toQuarter) return false;
  //         return true;
  //       })
  //       .reduce((sum, item) => sum + (item.goods_sold_cost || 0), 0);

  //     // --- Format result ---
  //     return total;
  //   };

  const computeOtherAmountQuarter = (fromDate, toDate, data) => {
    if (!data?.cost?.commisson?.overall?.costOveralloheramountcolumns) return 0;

    // Handle "All"
    if (fromDate === 'All' || !toDate) {
      return data.cost.commisson.overall.costOveralloheramountcolumns.reduce(
        (sum, item) => sum + (item.goods_sold_cost || 0),
        0
      );
    }

    // --- Parse from/to year & month ---
    const [fromYear, fromMonth] = fromDate.split('-').map(Number);
    const [toYear, toMonth] = toDate.split('-').map(Number);

    const fromQuarter = getQuarterByMonth(fromMonth);
    const toQuarter = getQuarterByMonth(toMonth);

    // --- Filter ---
    const total = data.cost.commisson.overall.costOveralloheramountcolumns
      .filter((item) => {
        const [itemYear, itemMonth] = item.year_month.split('-').map(Number);
        const itemQuarter = getQuarterByMonth(itemMonth);

        // year before range
        if (itemYear < fromYear || itemYear > toYear) return false;

        // same year as start
        if (itemYear === fromYear && itemQuarter < fromQuarter) return false;

        // same year as end
        if (itemYear === toYear && itemQuarter > toQuarter) return false;

        // in between years → always included
        return true;
      })
      .reduce((sum, item) => sum + (item.goods_sold_cost || 0), 0);

    return total;
  };

  const computeOtherAmountCurrentMonth = (data) => {
    const agentCommission =
      data?.cost?.commisson?.overall.costoverallotheramount;
    if (!Array.isArray(agentCommission)) return '0.00';

    const total = agentCommission.reduce(
      (sum, item) => sum + (item.goods_sold_cost || 0),
      0
    );

    return total;
  };

  const computeOtherAmountPreviousMonth = (data) => {
    const agentCommission =
      data?.cost?.commisson?.overall.costoverallpreviousmonthotheramount;
    if (!Array.isArray(agentCommission)) return '0.00';

    const total = agentCommission.reduce(
      (sum, item) => sum + (item.goods_sold_cost || 0),
      0
    );

    return total;
  };

  const dataoverall = data.cost?.commisson;

  const computeTotalAgentCommissionYear = (fromDate, toDate, data) => {
    let total = 0;

    if (fromDate === 'All' || !toDate) {
      total =
        data.cost?.commisson.overall.costOverAllCommissionColumns?.reduce(
          (sum, item) => sum + (item.agent_commission || 0),
          0
        ) || 0;
    } else {
      const fromYear = parseInt(fromDate.split('-')[0]);
      const toYear = parseInt(toDate.split('-')[0]);

      total =
        data.cost?.commisson.overall.costOverAllCommissionColumns
          ?.filter((item) => {
            const itemYear = parseInt(item.year_month.split('-')[0]);
            return itemYear >= fromYear && itemYear <= toYear;
          })
          .reduce((sum, item) => sum + (item.agent_commission || 0), 0) || 0;
    }

    // Format with commas and 2 decimal places
    return total;
  };

  // const totalSumAgentCommission =
  //   dataoverall.overall.costOverAllCommissionColumns
  //     .filter((item) => {
  //       const year = item.year_month.split("-")[0];
  //       if (targetYear === "All") return true;
  //       return year === targetYear;
  //     })
  //     .reduce((acc, curr) => acc + curr.agent_commission, 0);

  // const totalSumOtherAmount = dataoverall.overall.costOveralloheramountcolumns
  //   .map((item) => item.goods_sold_cost)
  //   .reduce((acc, curr) => acc + curr, 0);

  // const computeOtherAmountYear = (fromDate, toDate, data) => {
  //   let total = 0;

  //   if (fromDate === "All" || !toDate) {
  //     total =
  //       data.cost?.commisson.overall.costOveralloheramountcolumns?.reduce(
  //         (sum, item) => sum + (item.goods_sold_cost || 0),
  //         0
  //       ) || 0;
  //   } else {
  //     const fromYear = parseInt(fromDate.split("-")[0]);
  //     const toYear = parseInt(toDate.split("-")[0]);

  //     total =
  //       data.cost?.commisson.overall.costOveralloheramountcolumns
  //         ?.filter((item) => {
  //           const itemYear = parseInt(item.year_month.split("-")[0]);
  //           return itemYear >= fromYear && itemYear <= toYear;
  //         })
  //         .reduce((sum, item) => sum + (item.goods_sold_cost || 0), 0) || 0;
  //   }

  //   // Format with commas and 2 decimal places
  //   return total;
  // };

  // const totalSumOtherAmount = dataoverall.overall.costOveralloheramountcolumns
  //   .filter((item) => {
  //     const year = item.year_month.split("-")[0];
  //     if (targetYear === "All") return true;
  //     return year === targetYear;
  //   })
  //   .reduce((acc, curr) => acc + curr.goods_sold_cost, 0);

  const grouped = dataoverall.overall.costoveralltype.reduce((acc, item) => {
    const { cogs_type, goods_sold_cost } = item;
    if (!acc[cogs_type]) {
      acc[cogs_type] = 0;
    }
    acc[cogs_type] += goods_sold_cost;
    return acc;
  }, {});

  // Step 2: Convert to array and add Total row
  const resultArray = Object.entries(grouped).map(([type, total]) => ({
    name: type,
    value: total,
  }));

  // Step 3: Calculate grand total
  const grandTotal = resultArray.reduce((sum, item) => sum + item.value, 0);

  // Step 4: Add Total row
  resultArray.push({
    name: 'Total',
    value: grandTotal,
  });

  const resultArrayFill = resultArray.map((item) => {
    let fill;
    if (item.name === 'Total') {
      fill = 'url(#blueGradient)';
    } else if (item.value >= 0) {
      fill = 'url(#greenGradient)';
    } else {
      fill = 'url(#redGradient)';
    }

    return {
      ...item,
      fill,
    };
  });

  const groupedOtherType = dataoverall.overall.costoveralloheramounttype.reduce(
    (acc, item) => {
      const { cogs_type, goods_sold_cost } = item;
      if (!acc[cogs_type]) {
        acc[cogs_type] = 0;
      }
      acc[cogs_type] += goods_sold_cost;
      return acc;
    },
    {}
  );

  // Step 2: Convert to array and add Total row
  const resultArrayOthertype = Object.entries(groupedOtherType).map(
    ([type, total]) => ({
      name: type,
      value: total,
    })
  );

  const groupedCommissontype =
    dataoverall.overall.costoverallcommissonplan.reduce((acc, item) => {
      const { plan, agent_commission } = item;
      if (!acc[plan]) {
        acc[plan] = 0;
      }
      acc[plan] += agent_commission;
      return acc;
    }, {});

  // Step 2: Convert to array and add Total row
  const resultArrayCommissoplan = Object.entries(groupedCommissontype).map(
    ([type, total]) => ({
      month: type,
      revenue: total,
    })
  );

  const groupedCommissonSharePlan =
    dataoverall.overall.costoverallrevenueshareplan.reduce((acc, item) => {
      const { plan, goods_sold_cost } = item;
      if (!acc[plan]) {
        acc[plan] = 0;
      }
      acc[plan] += goods_sold_cost;
      return acc;
    }, {});

  // Step 2: Convert to array and add Total row
  const resultArrayCommissonSharePlan = Object.entries(
    groupedCommissonSharePlan
  ).map(([type, total]) => ({
    month: type,
    revenue: total.toFixed(2),
  }));

  // console.log("test", resultArrayCommissonSharePlan);

  const groupedRegion = dataoverall.overall.costoverallregional.reduce(
    (acc, item) => {
      const { regional, goods_sold_cost } = item;
      if (!acc[regional]) {
        acc[regional] = 0;
      }
      acc[regional] += goods_sold_cost;
      return acc;
    },
    {}
  );

  const colors = ['#2196F3', '#FFC107', '#4F6BF7']; // Only for top 3

  const totalRevenue = Object.values(groupedRegion)
    .filter((val) => val > 0)
    .reduce((sum, val) => sum + val, 0);

  const resultArrayRegion = Object.entries(groupedRegion)
    .filter(([_, total]) => total > 0)
    .map(([type, total]) => ({
      name: type,
      value: Math.abs(total),
      percent: totalRevenue
        ? parseFloat(((total / totalRevenue) * 100).toFixed(2))
        : 0,
    }))
    // .filter((item) => item.name !== "(None)")
    .map((item, index) => ({
      ...item,
      color: item.name === '(None)' ? '#E0E0E0' : colors[index % colors.length],
    }));

  const sumByState = (data) => {
    if (!Array.isArray(data)) {
      console.error('Invalid data: Expected an array but got', data);
      return {};
    }
    return data.reduce((acc, item) => {
      acc[item.state] = (acc[item.state] || 0) + item.goods_sold_cost;
      return acc;
    }, {});
  };

  const sumState = sumByState(dataoverall.overall.costoverallhigheststate);

  const revenueStateArray = Object.entries(sumState)
    .map(([state, revenue]) => ({
      state,
      revenue: parseFloat(revenue.toFixed(2)),
    }))
    .sort((a, b) => b.revenue - a.revenue)
    .slice(0, 5);

  const sumByMarket = (data) => {
    if (!Array.isArray(data)) {
      console.error('Invalid data: Expected an array but got', data);
      return {};
    }
    return data.reduce((acc, item) => {
      acc[item.market] = (acc[item.market] || 0) + item.goods_sold_cost;
      return acc;
    }, {});
  };

  const sumMarket = sumByMarket(dataoverall.overall.costoverallhighestmarket);

  const CostStateArray = Object.entries(sumMarket)
    .map(([state, revenue]) => ({
      state,
      revenue: parseFloat(revenue.toFixed(2)),
    }))
    .sort((a, b) => b.revenue - a.revenue)
    .slice(0, 10);

  // Step 1: Find the latest and previous months dynamically
  const uniqueMonths = [
    ...new Set(
      dataoverall.overall.costoverallcategoriesaccountrename.map(
        (item) => item.year_month
      )
    ),
  ].sort();

  const previousMonths = uniqueMonths[uniqueMonths.length - 2];

  // console.log("Latest:", latestMonth, "Previous:", previousMonths);

  // Step 2: Create a map of last month's revenue income
  const lastMonthData = {};
  dataoverall.overall.costoverallcategoriesaccountrename.forEach((item) => {
    if (item.year_month === previousMonths) {
      lastMonthData[item.account_dashboard_rename] = item.goods_sold_cost;
    }
  });

  // console.log("Latest:", lastMonthData, "Previous:", previousMonths);

  // Step 3: Transform the data
  // const transformedData = dataoverall.overall.costoverallcategoriesaccountrename
  //   .filter((item) => item.year_month === latestMonth) // Only keep the latest month dynamically
  //   .map((item) => {
  //     const lastMonthValue = lastMonthData[item.account_dashboard_rename] || 0;
  //     const percentChange =
  //       lastMonthValue === 0
  //         ? 100 // hoặc bạn có thể đặt là 0 hoặc 'N/A'
  //         : ((item.goods_sold_cost - lastMonthValue) / lastMonthValue) * 100;

  //     return {
  //       account_dashboard_rename: item.account_dashboard_rename,
  //       revenue_income: item.goods_sold_cost,
  //       revenue_income_lastmonth: lastMonthValue,
  //       percentChange: percentChange,
  //     };
  //   })
  //   .sort((a, b) => b.revenue_income - a.revenue_income);

  const transformedData = dataoverall.overall.costoverallcategoriesaccountrename
    // .filter((item) => item.year_month === latestMonth)
    .map((item) => {
      const lastPeriodValue =
        dataoverall.overall.costoverallcategoriesaccountrename
          .filter(
            (x) =>
              x.account_dashboard_rename === item.account_dashboard_rename &&
              x.range_type === 'previous'
          )
          .reduce((sum, x) => sum + (x.goods_sold_cost || 0), 0);
      const currentValue =
        dataoverall.overall.costoverallcategoriesaccountrename
          .filter(
            (x) =>
              x.account_dashboard_rename === item.account_dashboard_rename &&
              x.range_type === 'current'
          )
          .reduce((sum, x) => sum + (x.goods_sold_cost || 0), 0);

      // Safe percent change
      let percentChange = 0;
      if (lastPeriodValue === 0) {
        percentChange = currentValue > 0 ? 100 : 0;
      } else {
        percentChange =
          ((currentValue - lastPeriodValue) / lastPeriodValue) * 100;
      }

      return {
        account_dashboard_rename: item.account_dashboard_rename,
        revenue_income: currentValue,
        revenue_income_lastmonth: lastPeriodValue,
        percentChange,
      };
    })
    // prevent duplicates (optional)
    .filter(
      (v, i, a) =>
        a.findIndex(
          (t) => t.account_dashboard_rename === v.account_dashboard_rename
        ) === i
    )
    .sort((a, b) => b.revenue_income - a.revenue_income);

  return (
    <div className='frame-main-cost'>
      <SubHeader title='COST OF GOODS SOLD' />

      <div className='frame-cost-block1'>
        <div className='frame-cost-block1-left'>
          <div className='frame-cost-block1-card'>
            <TotalCard
              title='TOTAL COST OF GOODS SOLD'
              value={computeTotalCOGSCurrentMonth(data)}
              lastMonthValue={computeTotalCOGSPreviousMonth(data)}
              image={IconCost}
            />
          </div>
          <div className='frame-cost-block1-card'>
            <TotalCard
              title="TOTAL AGENT'S COMMISSION"
              value={computeTotalAgentCommissionCurrentMonth(data)}
              lastMonthValue={computeTotalAgentCommissionPreviousMonth(data)}
              image={IconCost}
            />
          </div>
          <div className='frame-cost-block1-card'>
            <TotalCard
              title='OTHER AMOUNTS'
              value={computeOtherAmountCurrentMonth(data)}
              lastMonthValue={computeOtherAmountPreviousMonth(data)}
              image={IconCost}
            />
          </div>
        </div>
        <div className='frame-cost-block1-right'>
          <div className='frame-cost-block1-right-top'>
            <div className='frame-cost-block1-right-top-box-total'>
              <div className='frame-cost-block1-right-top-item-box'>
                <h2>{createRevenueCardMonthTitle(firstRevenueYearMonth,lastRevenueYearMonth,fromDate,toDate)}</h2>
                <p className='frame-cost'>TOTAL COST OF GOODS SOLD</p>
                <h3>
                  ${toMillionFormat(computeTotalCOGSYear(fromDate, toDate, data))}
                </h3>

                <p className='frame-commission'>TOTAL AGENT'S COMMISSION</p>
                <h3>
                  ${toMillionFormat(computeTotalAgentCommissionYear(fromDate, toDate, data))}
                </h3>

                <p className='frame-cost-others'>OTHER AMOUNTS</p>
                <h3>
                  ${toMillionFormat(computeOtherAmountYear(fromDate, toDate, data))}
                </h3>
              </div>

              <hr className='vertical-line'/>

              <div className='frame-cost-block1-right-top-item-box'>
                 <h2>{createRevenueCardQuarterTitle(firstRevenueYearMonth,lastRevenueYearMonth,fromDate,toDate)}</h2>
                <p className='frame-cost'>TOTAL COST OF GOODS SOLD</p>
                <h3>
                  ${toMillionFormat(computeTotalCOGSQuarter(fromDate, toDate, data))}
                </h3>

                <p className='frame-commission'>TOTAL AGENT'S COMMISSION</p>
                <h3>${toMillionFormat(computeTotalAgentCommissionQuarter(fromDate, toDate, data))}
                </h3>

                <p className='frame-cost-others'>OTHER AMOUNTS</p>
                <h3>
                  ${toMillionFormat(computeOtherAmountQuarter(fromDate, toDate, data))}
                </h3>
              </div>
            </div>
          </div>
          <div className='frame-cost-block1-right-bottom'>
            <ColumnsChart
              datas={renameKeysCost(
                dataoverall.overall.costoverallmonthscolumns
              )}
              firstColor='#BABCFC'
              secondColor='#4348E3'
              height='100%'
            />
          </div>
        </div>
      </div>

      <div className='frame-cost-block2'>
        <div className='frame-cost-block2-left'>
          <div className='frame-cost-block2-left-title'>
            <h3>COST OF GOODS SOLD BY TYPES</h3>
          </div>
          <div className='frame-waterfall-chart'>
            <WaterFallChart data={resultArrayFill} />
          </div>
        </div>
        <div className='frame-cost-block2-right'>
          <div className='frame-cost-block2-right-title'>
            <h3>OTHER AMOUNTS DETAILS</h3>
          </div>
          <ClusterdBarChart data={resultArrayOthertype} />
        </div>
      </div>
      <div className='frame-cost-block3'>
        <div className='frame-cost-block3-left'>
          <div className='frame-cost-block3-left-title'>
            <h3>TOTAL AGENT'S COMMISSION BY PLAN</h3>
          </div>
          <ColumnsChart
            datas={resultArrayCommissoplan}
            firstColor='#E2FF8B'
            secondColor='#52B69A'
            height={430}
          />
        </div>
        <div className='frame-cost-block3-right'>
          <div className='frame-cost-block3-right-title'>
            <h3>TOTAL REVENUE SHARE BY PLAN</h3>
          </div>
          <ColumnsChart2
            datas={resultArrayCommissonSharePlan}
            firstColor='#E2FF8B'
            secondColor='#52B69A'
            height={430}
          />
        </div>
      </div>
      <div className='frame-cost-block4'>
        <div className='frame-cost-block4-left'>
          <div
            className='frame-cost-block4-card'
            style={{ paddingBottom: '10px' }}
          >
            <div className='frame-cost-block4-left-title'>
              <h3>TOTAL COST OF GOODS SOLD BY REGIONAL</h3>
            </div>
            <DonutChartLine data={resultArrayRegion} heights='320px' />
          </div>
          <div className='frame-cost-block4-card'>
            <div className='frame-cost-block4-left-title'>
              <h3>TOP 5 STATES WITH HIGHEST COGS</h3>
            </div>
            <RevenueBarChart
              height={400}
              firstColor='#E7DFF7'
              secondColor='#6B89F7'
              data={revenueStateArray}
            />
          </div>
          <div className='frame-cost-block4-card'>
            <div className='frame-cost-block4-left-title'>
              <h3>Total COGS by Market</h3>
            </div>
            <RevenueBarChart
              height={400}
              firstColor='#E7DFF7'
              secondColor='#6B89F7'
              data={CostStateArray}
            />
          </div>
        </div>
        <div className='frame-cost-block4-right'>
          <div className='frame-cost-block4-right-title'>
            <h3>
              TOTAL REVENUE & INCOME BY CATEGORIES (
              {createRevenueDateTitle(
                firstRevenueYearMonth,
                lastRevenueYearMonth,
                fromDate,
                toDate
              )}
              )
            </h3>
          </div>
          <RevenueTableCategories
            data={transformedData}
             from_date={fromDate}
            headerTitle={[
              'Categories',
              'Total COGS',
              'Total COGS (Last month)',
              '% Change',
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default OverAll;
